"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cn } from "@/utils/helpers";
import { TRUST_SIGNALS } from "./constants";
const TrustSignals: React.FC = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("z-10 bg-[#FFF9F3] shadow-[0_20px_50px_#0000000a] py-24 md:py-6 hidden lg:block relative");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className={t0}><div className="max-w-7xl mx-auto px-6 md:px-4"><div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-24">{TRUST_SIGNALS.map(_temp)}</div></div></section>;
    t2 = cn("border-[#bdc9c51a] border-y py-4 px-6 pb-16 block lg:hidden");
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t1}<section className={t2}><div className="flex flex-col md:flex-row justify-around items-center gap-8 md:gap-4 max-w-7xl mx-auto">{TRUST_SIGNALS.map(_temp2)}</div></section></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default TrustSignals;
function _temp(signal) {
  return <div key={signal.id} className={cn("group", "cursor-default text-center flex flex-col items-center")}><div className="mb-8 relative" style={{
      width: 64,
      height: 64
    }}><div className="bg-white absolute inset-0 text-[#005F52] shadow-[0_12px_40px_#735c000f] rounded-full flex justify-center items-center transition-all duration-500 ease-out group-hover:-translate-y-2 group-hover:shadow-[0_20px_50px_#735c001f]">{signal.desktopIcon}<div className="bg-[#FFE088] shadow-md w-6 h-6 rounded-full flex justify-center items-center absolute -bottom-1 -right-1 text-[#005F52]"><div className="w-3.5 h-3.5 flex justify-center items-center">{signal.desktopBadge}</div></div></div></div><h2 className="font-lora tracking-tight text-[#005F52] text-2xl font-semibold leading-8">{signal.label}</h2><div className="bg-[#fed65b33] rounded-full w-8 h-1 mt-4 transition-all duration-500 ease-out group-hover:w-16" /></div>;
}
function _temp2(signal_0, index) {
  return <React.Fragment key={signal_0.id}><div className="text-center flex flex-col items-center gap-1 md:gap-3"><div className="text-[#005F52] mb-1 md:mb-0 flex items-center justify-center">{signal_0.mobileIcon}</div><h5 className="font-outfit uppercase tracking-wider text-[#1A1C1A] text-xs font-bold leading-4">{signal_0.label}</h5><p className="whitespace-nowrap font-outfit text-[#3E4946] text-xs leading-4">{signal_0.description}</p></div>{index < TRUST_SIGNALS.length - 1 && <div className="bg-[#bdc9c533] w-px h-12 hidden md:block" />}</React.Fragment>;
}